import { createFileRoute, redirect } from "@tanstack/react-router"
import { FinanceReportsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

const VALID_TABS = ["overview", "reports"] as const

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/reports/$tabKey"
)({
  beforeLoad: ({ params }) => {
    if (!VALID_TABS.includes(params.tabKey as (typeof VALID_TABS)[number])) {
      throw redirect({
        to: "/finance/reports/$tabKey",
        params: { tabKey: "overview" },
      })
    }
  },
  component: () => (
    <AuthorizationGate resource={Resource.PAYMENT} action={Action.READ}>
      <FinanceReportsPage />
    </AuthorizationGate>
  ),
})
